import React from "react";
import { Link } from "gatsby";
import { cn } from "../lib/helpers";

import * as styles from "./ultherapyMain.module.css";
import * as commonStyles from "../styles/common.module.css";

import Ultherapy1 from "../images/ultherapy_1.jpg";
import Ultherapy2 from "../images/ultherapy_2.jpg";
import Ultherapy3 from "../images/ultherapy_3.jpg";
import Salma from "../images/salma.jpg";
import Quote1 from "../images/q1.png";
import Quote2 from "../images/q2.png";
import PortableText from "./portableText";

const benefits = [
  {
    title: "Chirurgická hloubka bez skalpelu",
    text: "Jako jediná technologie na světě působí Ultherapy Prime v hloubce až 4,5 mm – tedy přímo v tkáňové vrstvě SMAS, se kterou pracují plastičtí chirurgové při klasickém faceliftu.",
  },
  {
    title: 'Ultrazvukové „oči" pro vaši bezpečnost',
    text: "Díky unikátní technologii DeepSEE™ vidíme pod vaši kůži v reálném čase. Každý impulz energie cílíme s chirurgickou přesností tam, kde přinese největší efekt, a vyhýbáme se kosti či cévám.",
  },
  {
    title: "Aktivace vlastního mládí",
    text: 'Nejde o výplň ani cizorodou látku. Ultherapy Prime „restartuje" vaše buňky. Masivní produkce nového kolagenu zajistí, že výsledek je přirozený a váš obličej neztrácí svou mimiku.',
  },
  {
    title: "Jedno ošetření, dlouhotrvající efekt",
    text: "Na rozdíl od jiných metod stačí u Ultherapy Prime obvykle pouze jedna návštěva. Výsledky se postupně vyvíjejí a gradují v průběhu 2–3 měsíců, přičemž efekt přetrvává rok i déle.",
  },
  {
    title: "Maximální komfort (Nová generace 2026)",
    text: "Verze Prime byla navržena tak, aby byl zákrok rychlejší a pocitově příjemnější. Žádná omezení po ošetření – z kliniky můžete jít rovnou na pracovní schůzku nebo na večeři.",
  },
];

const areas = [
  {
    label: "Lower Face",
    text: "Zpevnění povislých tváří a vyrýsování linie dolní čelisti",
  },
  {
    label: "Brow Lift",
    text: "Přirozený lifting obočí a vyhlazení vrásek kolem očí",
  },
  {
    label: "Facelift",
    text: "Efektivní zpevnění tváří, vyrýsování čelisti, eliminace podbradku. Kompletní ošetření obličeje.",
  },
  {
    label: "Neck Lift",
    text: "Vyhlazení vějířkovitých vrásek v oblasti krku a hrudníku.",
  },
  {
    label: "Chin Lift",
    text: "Zpevnění podbradku a vyrýsování kontur brady.",
  },
];

const milestones = [
  {
    year: "Před rokem 2004",
    text: "Koncept HIFU (High-Intensity Focused Ultrasound) byl původně vyvíjen pro léčbu nádorů. Vědci ze společnosti Ulthera, Inc. si uvědomili, že přesně kalibrovaná energie může místo destrukce vyvolat v kůži řízenou regeneraci.",
  },
  {
    year: "2009 – Revoluční rok",
    text: 'Ultherapy se stala prvním a jediným přístrojem na světě, který získal prestižní americkou certifikaci FDA pro neinvazivní lifting obočí. Jako první směla oficiálně používat slovo „lifting".',
  },
  {
    year: "2012 – 2014",
    text: "Ultherapy získala schválení FDA pro lifting kůže na krku, podbradku a pro vyhlazení vrásek v oblasti dekoltu. Německá firma Merz Aesthetics akvírovala Ulthera, Inc. za přibližně 600 milionů dolarů.",
  },
  {
    year: "HIFU fenomén",
    text: "Díky úspěchu Ultherapy se trh zaplavil levnými kopiemi z Asie. Ultherapy však zůstává jediným systémem kombinujícím léčebný ultrazvuk se zobrazovacím (DeepSEE™) – lékař vidí na monitoru přesně kam střílí.",
  },
  {
    year: "2024 – 2026 – Ultherapy Prime",
    text: "Největší technologická modernizace v historii značky. Ošetření je o 20 % rychlejší, komfortnější díky pokročilejším algoritmům přenosu energie. K roku 2026 provedeno více než 2,5 milionu ošetření po celém světě.",
  },
];

const testimonialContent = [
  {
    _key: "ulth-ref-01",
    _type: "block",
    children: [
      {
        _key: "ulth-ref-01-span",
        _type: "span",
        marks: [],
        text: `„Vždycky jsem pevně věřila v sílu energie, a proto jsem nadšená ze spolupráce s Ultherapy PRIME. Je to pokročilá léčba, která využívá mikrofokusovanou ultrazvukovou energii a zobrazování v reálném čase, což mi dává přirozeně vypadající lifting s výsledky, které mohou vydržet až rok nebo i déle. Ultherapy PRIME mi přizpůsobuje mou léčbu tím, že působí na správné vrstvy pokožky, aktivuje můj regenerační potenciál a zvyšuje mou vlastní produkci kolagenu a elastinu. Nejlepší na tom je, že je neinvazivní, trvá pouze jedno sezení a není potřeba žádná rekonvalescence.“`,
      },
    ],
    markDefs: [],
    style: "normal",
  },
];

function UltherapyMain() {
  return (
    <div className={styles.container1}>
      <h1 className={cn(styles.headline, commonStyles.colorAccent, commonStyles.fontButlerMedium)}>
        Ultherapy
      </h1>

      {/* Hero */}
      <h2 className={cn(styles.title, commonStyles.colorAccent, commonStyles.fontButlerMedium)}>
        Ultherapy® Prime: Budoucnost liftingu bez skalpelu!
      </h2>
      <h3
        className={cn(styles.titleSmall, commonStyles.colorAccent, commonStyles.fontButlerMedium)}
      >
        Zastavte čas s nejpřesnější a nejbezpečnější technologií současnosti.
      </h3>

      <div className={cn(styles.container2)}>
        <div className={styles.container3}>
          <p className={cn(styles.heroIntro, commonStyles.colorDarkGray, commonStyles.fontButler)}>
            Objevte Ultherapy® Prime – jediné neinvazivní ošetření s FDA certifikací, které díky
            cílenému působení mikro fokusovaného ultrazvuku viditelně zpevňuje a pozvedá pleť tak,
            jak to bylo dříve možné jen chirurgicky.
          </p>
          <p className={cn(styles.bodyText, commonStyles.colorDarkGray, commonStyles.fontButler)}>
            Ultherapy® je již léta zlatým standardem v estetické medicíně. Verze Prime však posouvá
            hranice ještě dál. Je to inteligentnější, rychlejší a komfortnější cesta k omlazení,
            která nevyžaduje ani jeden řez, vpich, žádnou narkózu a nulový čas na zotavenou.
          </p>
        </div>
        <div>
          <div className={styles.imageWrapper}>
            <img
              className={styles.placeholderImage}
              src={Ultherapy1}
              alt="Ultherapy Prime ošetření"
            />
          </div>
        </div>
      </div>

      <hr className={styles.divider} />

      {/* Benefits */}
      <h2
        className={cn(styles.sectionTitle, commonStyles.colorAccent, commonStyles.fontButlerMedium)}
      >
        Proč zvolit právě Ultherapy® Prime?
      </h2>
      <div className={cn(styles.container2)}>
        <div className={styles.mAuto}>
          <div className={styles.imageWrapper}>
            <img
              className={styles.placeholderImageWide}
              src={Ultherapy3}
              alt="Ultherapy Prime technologie"
            />
          </div>
        </div>
        <div className={styles.container3}>
          <ul className={styles.benefitsList}>
            {benefits.map((b, i) => (
              <li key={i} className={styles.benefitItem}>
                <span
                  className={cn(
                    styles.benefitTitle,
                    commonStyles.colorAccent,
                    commonStyles.fontReleway
                  )}
                >
                  {b.title}
                </span>
                <span
                  className={cn(
                    styles.benefitText,
                    commonStyles.colorDarkGray,
                    commonStyles.fontButler
                  )}
                >
                  {b.text}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <hr className={styles.divider} />

      {/* Areas */}
      <h2
        className={cn(styles.sectionTitle, commonStyles.colorAccent, commonStyles.fontButlerMedium)}
      >
        Jaké oblasti dokáže Ultherapy Prime ošetřit?
      </h2>
      <div className={styles.areasGrid}>
        {areas.map((area, i) => (
          <div key={i} className={styles.areaCard}>
            <div
              className={cn(styles.areaLabel, commonStyles.colorAccent, commonStyles.fontReleway)}
            >
              {area.label}
            </div>
            <div
              className={cn(styles.areaText, commonStyles.colorDarkGray, commonStyles.fontButler)}
            >
              {area.text}
            </div>
          </div>
        ))}
      </div>

      <div className={cn(styles.imageWrapperWide, styles.mWidth640, styles.mAuto)}>
        <img
          className={styles.placeholderImageWide}
          src={Ultherapy2}
          alt="Oblasti ošetření Ultherapy Prime"
        />
      </div>

      <hr className={styles.divider} />
      <div className={cn(styles.cenik, commonStyles.colorAccent, commonStyles.fontReleway)}>
        <Link to={"/cenik#ultherapy-prime"}>Ceník</Link>
      </div>
      <hr className={styles.divider} />

      {/* Target audience */}
      <h2
        className={cn(styles.sectionTitle, commonStyles.colorAccent, commonStyles.fontButlerMedium)}
      >
        Pro koho je ošetření ideální?
      </h2>
      <p className={cn(styles.bodyText, commonStyles.colorDarkGray, commonStyles.fontButler)}>
        Ultherapy Prime je perfektní volbou pro muže i ženy, kteří pozorují první známky povadlosti
        pleti, ale nejsou připraveni na operaci, nebo pro ty, kteří chtějí proces stárnutí
        proaktivně a diskrétně zpomalit.
      </p>

      {/* Fact block */}
      <div className={styles.factBlock}>
        <p className={cn(styles.factText, commonStyles.colorAccent, commonStyles.fontButlerMedium)}>
          Fakta místo slibů:
        </p>
        <p className={cn(styles.bodyText, commonStyles.colorDarkGray, commonStyles.fontButler)}>
          Ultherapy Prime má za sebou více než 50 klinických studií a miliony spokojených pacientů
          po celém světě, což z ní dělá nejbezpečnější volbu na trhu.
        </p>
      </div>

      <hr className={styles.divider} />
      {/* History */}
      <h2
        className={cn(styles.sectionTitle, commonStyles.colorAccent, commonStyles.fontButlerMedium)}
      >
        Historie Ultherapy
      </h2>
      <p className={cn(styles.bodyText, commonStyles.colorDarkGray, commonStyles.fontButler)}>
        Historie Ultherapy je fascinujícím příběhem o tom, jak se technologie původně určená k
        diagnostice proměnila v nejúčinnější neinvazivní „skalpel" v estetické medicíně.
      </p>

      <div className={styles.historyBlock}>
        {milestones.map((m, i) => (
          <div key={i} className={styles.milestone}>
            <div
              className={cn(
                styles.milestoneYear,
                commonStyles.colorAccent,
                commonStyles.fontReleway
              )}
            >
              {m.year}
            </div>
            <div
              className={cn(
                styles.milestoneText,
                commonStyles.colorDarkGray,
                commonStyles.fontButler
              )}
            >
              {m.text}
            </div>
          </div>
        ))}
      </div>

      <p
        className={cn(styles.bodyText, commonStyles.colorDarkGray, commonStyles.fontButler)}
        style={{ marginTop: "2em" }}
      >
        Historie Ultherapy dokazuje, že nejde o „módní výstřelek", ale o technologii prověřenou více
        než 15 lety klinických studií. Zatímco jiné metody přicházejí a odcházejí, Ultherapy zůstává
        pro rok 2026 měřítkem, ke kterému se všechny ostatní neinvazivní liftingy přirovnávají.
      </p>

      <hr className={styles.divider} />

      {/* Testimonials */}
      <div className={cn(styles.container2, commonStyles.colorDarkGray, commonStyles.fontButler)}>
        <div className={styles.container3}>
          <h2
            className={cn(styles.titleDN, commonStyles.colorAccent, commonStyles.fontButlerMedium)}
          >
            Salma Hayek
          </h2>
          <h3
            className={cn(styles.titleDNT, commonStyles.colorAccent, commonStyles.fontButlerMedium)}
          >
            „Jsem s výsledky moc spokojená, Ultherapy PRIME® je opravdu lifting, který je vidět“
          </h3>
          <PortableText blocks={testimonialContent} />
          <div className={cn(styles.subtitle, commonStyles.colorAccent, commonStyles.fontReleway)}>
            Ambasadorka Ultherapy® Prime
          </div>
        </div>
        <div className={styles.quoteImageWrapper}>
          <img className={styles.quoteDecor1} src={Quote1} alt="" />
          <img className={styles.placeholderImage} src={Salma} alt="Salma Hayek Ultherapy® Prime" />
          <img className={styles.quoteDecor2} src={Quote2} alt="" />
        </div>
      </div>
    </div>
  );
}

export default UltherapyMain;
